import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { CANCELLED, ID, RECEIVED } from "APP_ROOT/constants";
import Form from "./Form";

export default function SendEmail({ warning, record, label, url, type }) {
  if (record.get(CANCELLED) || record.get(RECEIVED)) {
    return false;
  }

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="envelope-o" fixed />
          &nbsp;Send {label}
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Are You Sure?</h4>
            </Header>
            <Form
              label={label}
              close={close}
              recordId={record.get(ID)}
              url={url}
              type={type}
              formWarning={warning}
              disabledReason={warning}
            />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

SendEmail.propTypes = {
  warning: T.string,
  record: T.instanceOf(Map).isRequired,
  label: T.string.isRequired,
  url: T.shape({}).isRequired,
  type: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/SendEmail/SendEmail.jsx